import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const CRMDatePicker = ({
                                defaultDate,
                                onChange,
                                showTime,
                                onShowTimeChange,
                              }: {
  defaultDate: Date | string;
  onChange: (date: Date) => void;
  onShowTimeChange: (show: boolean) => void;
  showTime: boolean;
}) => {
  const parseDate = (d: Date | string): Date => (typeof d === 'string' ? new Date(d) : d);
  const [selectedDate, setSelectedDate] = useState<Date>(parseDate(defaultDate));
  const [displayTime, setDisplayTime] = useState<boolean>(showTime);
  
  useEffect((): void => {
    setSelectedDate(parseDate(defaultDate));
  }, [defaultDate]);

  useEffect((): void => {
    setDisplayTime(showTime);
  }, [showTime])

  const handleChange = (date: Date | null): void => {
    if (date) {
      setSelectedDate(date);
      onChange(date);
    }
  };
  
  const handleUseTimeChange = (): void => {
    const next: boolean = !displayTime;
    setDisplayTime(next);
    onShowTimeChange(next);
  }

  return (
    <>
      <div className="form-group">
        <div className="input-group">
          <span className="input-group-text">
            <span className="fas fa-calendar-alt"></span>
          </span>
          <DatePicker
            selected={selectedDate}
            onChange={handleChange}
            showTimeInput={displayTime}
            dateFormat={displayTime ? "dd-MM-yyyy HH:mm" : "dd-MM-yyyy"}
            className="form-control rounded-start-0"
          />
        </div>
        <div className="form-check form-switch form-switch-md pt-2">
          <input className="form-check-input" type="checkbox" id="UseDateAndTime" checked={displayTime} onChange={handleUseTimeChange} />
          <label className="form-check-label" htmlFor="UseDateAndTime"> include time</label>
        </div>
      </div>
    </>
  );
};
